import Vue from 'vue';
import Router from 'vue-router';
import Store from '@/store';

import Splash from '@/views/Splash.vue';
import Laureat from '@/views/Laureat.vue';
import Current from '@/views/Current.vue';
import Ceremonie from '@/views/Ceremonie.vue';
import Laureats from '@/views/Laureats.vue';
import Contact from '@/views/Contact.vue';
import About from '@/views/About.vue';
// import Temporaire from '@/views/Temporaire.vue';
import app from '@/main.js';

Vue.use(Router);

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      app.$root.$once('scrollAfterEnter', () => {
        if (savedPosition) {
          resolve(savedPosition);
        } else {
          resolve({ x: 0, y: 0 });
        }
      });
    });
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   name: 'current',
    //   component: Current,
    // },
    {
      path: '/',
      name: 'splash',
      component: Splash,
    },
    // {
    //   path: '/temporaire',
    //   name: 'temporaire',
    //   component: Temporaire,
    // },
    {
      path: '/ceremonie',
      name: 'ceremonie',
      component: Ceremonie,
    },
    {
      path: '/laureat/:year/:slug',
      name: 'laureat',
      component: Laureat,
    },
    {
      path: '/laureats',
      name: 'current',
      component: Current,
    },
    {
      path: '/laureats/:filter',
      name: 'laureats',
      component: Laureats,
      children: [
        {
          path: ':year/:slug',
          component: Laureat,
          name: 'laureats-laureat',
        },
      ],
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
    },
    {
      path: '/about/:slug?',
      name: 'about',
      component: About,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

router.beforeEach((to, from, next) => {
  let bS = Store.getters.backState;
  if (to.name === 'laureats-laureat' && !bS) {
    next({
      replace: true,
      path: '/laureat/' + to.params.year + '/' + to.params.slug,
    });
  } else {
    next();
  }
});

export default router;
